import { MDBBtn, MDBIcon } from "mdbreact"
import React, { Component } from "react"
import Lightbox from 'react-image-lightbox'
import RatingTooltip from "react-rating-tooltip"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Form, Input, Label, Media, Row } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import { CALIFICACION_SOLICITUD, TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes"
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones";
import HistorialFormulario from "../../components/historial/historialFormulario"
import _valid from "../../validations"
import "../calificacionSolicitud/calificacionSolicitud.css"

const starStyle = {
    color: '#ff6d75'
}

export default class CalificacionSolicitud extends Component {

    constructor(props) {
        super(props);
        const hayRegistro = _valid(props.datos);
        this.apiRest = new ApiRest(props);

        this.pathnameAnterior = props.pathnameAnterior

        this.state = {
            idRegistro: props.props,
            registro: hayRegistro ? props.datos.registro : {
                estado: 4,
                valor: 0,
                razon_rechazo: "",
                img_calificacion: undefined,
            },
            modalEstaAbierto: false,
            colapsar: true,
            comentario: "",
            imgCalificacionBase64: hayRegistro && _valid(props.datos.registro) && _valid(props.datos.imgCalificacionBase64) ? props.datos.imgCalificacionBase64 : undefined,
            verImagenEnGrande: false
        };
        this.colapsar = this.colapsar.bind(this);
        this.actualizarImagen = this.actualizarImagen.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.actualizarCalificacion = this.actualizarCalificacion.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.actualizarRegistroConValoresNumericos = this.actualizarRegistroConValoresNumericos.bind(this);
    }

    componentDidMount() {
        this.obtenerDatosSolicitudCompleta();
        this.setState(pre => ({ ...pre, registro: { ...pre.registro, estado: 4 } }));
    }

    obtenerDatosSolicitudCompleta(id) {
        const idRegistro = this.state.idRegistro || id;
        if (!isNaN(idRegistro)) {
            this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ registro: resultado.data });
                    if (_valid(resultado.imgCalificacionBase64)) {
                        this.setState({ imgCalificacionBase64: resultado.imgCalificacionBase64 })
                    }
                }
            });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    actualizarCalificacion = calificacion => {
        if (calificacion == 1){
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, valor: calificacion, estado: 5 }
            }));
        } else if (calificacion >= 2 && calificacion <= 5) {
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, valor: calificacion, estado: 4, razon_rechazo: "" }
            }));
        }
    }

    actualizarRegistroConValoresNumericos({ target: { name, value } }) {
        value = parseInt(value);
        if (value === 4) { //aceptado
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, [name]: value, razon_rechazo: "", valor: 5 }
            }));
        } else {
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, [name]: value }
            }));
        }

        if (name == 'estado' && value == 5) { //rechazado
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, valor: 1 }
            }));
        }
    }

    actualizarImagen = ({ target: { name, files } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: files[0] }
        }));
    }

    almacenarRegistro(historialGuardado) {
        if (this.datosRegistroValidos()) {
            const { registro } = this.state;
            let datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_calificacion");

            if (_valid(registro.id)) {
                this.apiRest.putFiles('/calificacionActualizar/' + registro.id, datosFormulario).then(resultado => {
                    if (resultado.exitoso) {
                        this.setState({ registro: resultado.data, imgCalificacionBase64: resultado.imgCalificacionBase64 })
                        toastr.success('Datos almacenados exitosamente!');
                        //this.enviarEmail();
                        this.guardarEnHistorial();
                        this.calificarOdoo(registro.id);
                        this.whatsappCalificarSolicitud(registro.id);
                        this.props.props.actualizarFila(registro.id);                        
                        this.props.props.changeSideAbierto();
                        //if(registro.estado == 5){ //crear un clon del ticket cuando es Rechazado (Pendiente el 8 No Aceptado)
                        //    this.clonarSolicitud(registro.id);
                        //}
                        //this.props.props.history.replace(this.pathnameAnterior);
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }
    /*almacenarRegistro(historialGuardado) {
        if (this.datosRegistroValidos()) {
            if (typeof (historialGuardado) === "boolean") {
                if (historialGuardado) {
                    this.enviarValores();
                } else {
                    toastr.error("No se pudo guardar el historial, por favor intente de nuevo.");
                }
                this.setState({ modalEstaAbierto: false });
            } else {
                this.setState({ modalEstaAbierto: true });
            }
        }
    }*/

    //correo para el encargado del departamento
    enviarEmail = () => {
        const {
            registro
        } = this.state;
        //console.log(registro.colaborador);
        this.apiRest.get('/correoCalificacion/' + registro.id).then(resultado => {
            if (resultado.exitoso) {
                let respuesta = (resultado.data);
                toastr.success("Se ha enviado un correo a " + respuesta.email + " para notificarle la calificación de la solicitud.");
            }else{
                toastr.error("No se pudo enviar el correo.");
            }
        });
    }

    enviarValores = async () => {
        const { registro } = this.state;
        let datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_calificacion");

        if (_valid(registro.id)) {
            await this.apiRest.putFiles('/calificacionActualizar/' + registro.id, datosFormulario).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ registro: resultado.data, imgCalificacionBase64: resultado.imgCalificacionBase64 })
                    toastr.success('Datos almacenados exitosamente!');
                    //this.enviarEmail();
                    this.props.props.actualizarFila(registro.id);
                    this.props.props.changeSideAbierto();
                    //this.props.props.history.replace(this.pathnameAnterior);
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    datosRegistroValidos() {
        const { registro } = this.state;

        if (registro.estado == 5 && registro.razon_rechazo == '') {
            toastr.error("Razon de rechazo es requerido.");

            return false;
        }

        if (_valid(registro.valor)) {
            return true;
        }
        if (!_valid(registro.valor)) {
            toastr.error("Es necesario seleccionar una calificacion (Estrellas)");
            return false;
        }
    }

    guardarEnHistorial(){
        const { comentario } = this.state;
        if (_valid(comentario)) {
            const { estado, id } = this.state.registro;
            let datos = { comentario };
            if (estado !== undefined) {
                datos["estado"] = parseInt(estado);
            }
            if (id) {
                datos["solicitud"] = id;
            }
            this.apiRest.post('/historial', datos).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success("Se guardo el historial.");
                } else {
                    toastr.error("No se guardo comentario para el historial.");
                }
            });
        }
    }

    whatsappCalificarSolicitud(id) {
        this.apiRest.get('/whatsappCalificarSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Whatsapp enviado exitosamente!');
            } else {
                console.log('Vaya! Ha ocurrido un error al enviar whatsapp, por favor intenta nuevamente.');
            }
        });
    }

    calificarOdoo(id) {
        this.apiRest.get('/calificarOdooSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Calificar en Odoo exitosamente!');
            } else {
                console.log('Vaya! Ha ocurrido un error al calificar en odoo, por favor intenta nuevamente.');
            }
        });
    }

    clonarSolicitud(id) {
        this.apiRest.get('/solicitudClonar/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Solicitud clonada correctamente');
            } else {
                toastr.error('Vaya! Ha ocurrido un error al clonar la solicitud, por favor intenta nuevamente.');
            }
        });
    }

    // Renderizando el Dom
    render() {
        const {
            registro,
            modalEstaAbierto,
            imgCalificacionBase64,
            colapsar,
            verImagenEnGrande,
        } = this.state;

        return (
            <div>
                <React.Fragment>
                    <Card>
                        <CardBody>
                            <Link onClick={this.colapsar} className="text-dark" to="#">
                                <div className="p-4">
                                    <Media className="d-flex align-items-center">
                                        <div className="me-3">
                                            <i className="uil uil-receipt text-primary h2"></i>
                                        </div>
                                        <div className="flex-1 overflow-hidden">
                                            <h5 className="font-size-16 mb-1">Calificacion de solicitud</h5>
                                            <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                        </div>
                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                    </Media>
                                </div>
                            </Link>
                            <Collapse isOpen={colapsar}>
                                <div className="p-4 border-top">
                                    <Form>
                                        <Row>
                                            <Col lg={4}>
                                                <Label className="form-label">
                                                    Estado de Solicitud:
                                                </Label>
                                                <select
                                                    value={registro.estado}
                                                    onChange={this.actualizarRegistroConValoresNumericos}
                                                    name="estado"
                                                    className="form-control"
                                                >
                                                    <option key={4} value={4}>Aceptado</option>
                                                    <option key={5} value={5}>Rechazado</option>
                                                </select>
                                            </Col>

                                            <Col lg={6}>
                                                <label className="font-16 m-b-15">Calificaci&oacute;n:</label>
                                                <Row>
                                                    <Col lg={3} sm={3} xs={5}>
                                                        <RatingTooltip
                                                            defaultRating={registro.valor}
                                                            max={5}
                                                            onChange={calificacion => this.actualizarCalificacion(calificacion)}
                                                            value={"valor"}
                                                            ActiveComponent={
                                                                <i
                                                                    key={"active_1"}
                                                                    className="mdi mdi-star text-warning"
                                                                    style={starStyle}
                                                                />
                                                            }
                                                            InActiveComponent={
                                                                <i
                                                                    key={"active_01"}
                                                                    className="mdi mdi-star-outline text-muted"
                                                                    style={starStyle}
                                                                />
                                                            }
                                                        />
                                                        <p>{_valid(registro.valor) && CALIFICACION_SOLICITUD[registro.valor]}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <p />
                                        {
                                            registro.estado === 5 &&
                                            <Row>
                                                <Col lg={12}>
                                                    <label>
                                                        Razón de Rechazo:
                                                    </label>
                                                    <Input
                                                        value={registro.razon_rechazo}
                                                        onChange={this.actualizarValores}
                                                        name="razon_rechazo"
                                                        type="textarea"
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            registro.estado === 4 &&
                                            <Row>
                                                <Col lg={12}>
                                                    <Label htmlFor="comentario" className="form-label">
                                                        Comentario
                                                    </Label>
                                                    <Input
                                                        value={this.state.registro.comentario}
                                                        onChange={({ target: { value } }) => this.setState(ant => ({ ...ant, comentario: value }))}
                                                        name="comentario"
                                                        type="textarea"
                                                        className="form-control"
                                                        placeholder="Escribe un comentario"
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        <br />
                                        <Row>
                                            <Col lg={4}>
                                                <Label htmlFor="img_calificacion" className="form-label">
                                                    Subir Imagen:
                                                </Label>
                                                <input
                                                    name="img_calificacion"
                                                    onChange={this.actualizarImagen}
                                                    className="form-control"
                                                    type="file"
                                                />
                                            </Col>
                                            <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                <Label htmlFor="img_calificacion" className="form-label">
                                                    Imagen
                                                </Label>
                                                <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                    {imgCalificacionBase64 !== undefined && <img width="100%" src={`data:image/jpeg;base64,${imgCalificacionBase64}`} alt="Imagen" />}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                                <Row>
                                    <Col lg={12} className="text-end">
                                        {/*<MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.props.history.replace(this.pathnameAnterior) }}>
                                            <MDBIcon icon="fas fa-arrow-left" />{' '}
                                            Regresar
                                        </MDBBtn>
                                        {' '}*/}
                                        <MDBBtn className="waves-effect" color="success" onClick={this.almacenarRegistro}>
                                            <MDBIcon icon="fas fa-user-check" /> {' '}
                                            Calificar
                                        </MDBBtn>
                                    </Col>
                                </Row>
                            </Collapse>
                        </CardBody>
                    </Card>
                </React.Fragment>
                {modalEstaAbierto && <HistorialFormulario
                    solicitud={registro.id}
                    estado={registro.estado}
                    estadoModal={modalEstaAbierto}
                    seGuardoEnHistorial={historialGuardado => this.almacenarRegistro(historialGuardado)}
                />}
                {verImagenEnGrande && <Lightbox mainSrc={`data:image/jpeg;base64,${imgCalificacionBase64}`} onCloseRequest={() => this.setState({ verImagenEnGrande: false })} />}
            </div>
        );
    }
}